import { useNotify } from "@utils";
import { Modal } from "antd";
import QrReader from "modern-react-qr-reader";
import { useTranslation } from "react-i18next";

interface IProps {
  open: boolean;
  callback: (value: string) => void;
  handleModal: () => void;
}
export const ComponentReader = ({ open, callback, handleModal }: IProps) => {
  const { t } = useTranslation();
  const { error } = useNotify();
  const handleScan = (data: string) => {
    if (data === null) return;
    callback(data);
  };
  const handleError = (err: any) => {
    error(err);
  };
  return (
    <Modal open={open} onCancel={handleModal} footer={null}>
      <QrReader
        delay={300}
        facingMode={"environment"}
        onError={handleError}
        onScan={handleScan}
        style={{ width: "100%" }}
      />
    </Modal>
  );
};
